import useWindowSize from "../hooks/useWindowSize";

export interface IWithWindowSizeProp {
  windowSize: { width: number; height: number };
}

export const withWindowSize = <P extends object>(Component: any) => {
  return (props: P) => {
    const windowSize = useWindowSize();
    return <Component {...props} windowSize={windowSize} />;
  };
};
